import {
  Box,
  Tab,
  Stack,
  Tabs,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Button,
  Grid,
} from "@mui/material";
import { Card } from "../../ui/Card";
import Title from "../../ui/Title";
import { StyledSeperator } from "../../ui/Seperator";
import { useEffect, useState } from "react";
import {
  getServicerApi,
  ServiceDetailsType,
  changeServicApi,
} from "./setupApi";
import {
  LocalPostOfficeIcon,
  LocalShippingIcon,
  DoneAllIcon,
  ClearIcon,
  ContactPhoneIcon,
} from "../../../common/iconsData";
import styled from "styled-components";
import toast from "react-hot-toast";
import { NoDataFound } from "../../../common/NoDataFound";

interface ServiceType {
  active_for_pickup: number;
  pincode_serviceable: number;
  service_count: string;
}
const Services = () => {
  const Card2 = styled.div`
    background-color: #f8fafd;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.1);
    min-height: auto;
  `;

  const [serviceData, setServiceData] = useState<ServiceDetailsType[]>([]);
  const [serviceDetail, setServiceDetail] = useState<ServiceType>();
  const [serviceStates, setServiceStates] = useState("activated");
  const [activeTab, setActiveTab] = useState(0);
  const [refresh, setRefresh] = useState(0);

  const handleServiceStatus = (service_id: string, t: boolean) => {
    let tex = "";
    if (t === true) {
      tex = "deactivate";
    } else {
      tex = "activate";
    }

    changeServicApi({
      status: tex,
      service_id,
    })
      .then((data) => {
        toast.success("Service successfully " + tex);
        setRefresh(refresh + 1);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getServicerApi(serviceStates)
      .then((data) => {
        setServiceDetail(data?.data?.data);
        const finalData: ServiceDetailsType[] = data?.data?.data?.service;
        finalData?.map((el, index) => {
          el.id = index + 1;
        });
        setServiceData(finalData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [activeTab, refresh]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: any) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Title title="Services" />
      </Stack>

      <StyledSeperator />

      <Grid container spacing={2} mb={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <Stack
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography fontSize={"14px"} fontWeight={"600"}>
                Service
              </Typography>
              <StyledSeperator
                style={{
                  margin: "10px",
                  width: "100%",
                }}
              />
              <Typography fontSize={"16px"} fontWeight={"600"}>
                {serviceDetail && serviceDetail?.service_count}
              </Typography>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <Stack
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography fontSize={"14px"} fontWeight={"600"}>
                Pincode Serviceable
              </Typography>
              <StyledSeperator
                style={{
                  margin: "10px",
                  width: "100%",
                }}
              />
              <Typography fontSize={"24px"} fontWeight={"600"}>
                {serviceDetail && serviceDetail?.pincode_serviceable}
              </Typography>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <Stack
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography fontSize={"14px"} fontWeight={"600"}>
                Pincode Active for Pickup
              </Typography>
              <StyledSeperator
                style={{
                  margin: "10px",
                  width: "100%",
                }}
              />
              <Typography fontSize={"24px"} fontWeight={"600"}>
                {serviceDetail && serviceDetail?.active_for_pickup}
              </Typography>
            </Stack>
          </Card>
        </Grid>
      </Grid>

      <Card>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e: React.SyntheticEvent<Element, Event>, number: any) =>
              handleTabChange(e, number)
            }
            variant="scrollable"
          >
            <Tab
              label={"Activated"}
              onClick={() => setServiceStates("activated")}
            />
            ;
            <Tab
              label={"Deactivated"}
              onClick={() => setServiceStates("deactivated")}
            />
            ;
            <Tab label={"All"} onClick={() => setServiceStates("all")} />;
          </Tabs>
        </Box>

        <TableContainer
          sx={{
            marginTop: "20px",
          }}
        >
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Courier Name</TableCell>
                <TableCell>Delivery Info</TableCell>
                <TableCell>POD</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {serviceData &&
                serviceData?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row?.service_name}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "12px",
                        }}
                      >
                        <ContactPhoneIcon
                          color="primary"
                          sx={{
                            fontSize: "25px",
                            border: "1px solid #eceef0",
                          }}
                        />
                        Delivery Boy Number: {row?.delivery_boy_number}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "12px",
                        }}
                      >
                        <LocalPostOfficeIcon
                          color="primary"
                          sx={{
                            fontSize: "22px",
                            border: "1px solid #eceef0",
                            borderRadius: "50%",
                            padding: "0px",
                          }}
                        />
                        POD:{row?.POD}
                      </Box>
                      <br />
                      <Box
                        sx={{
                          display: "flex",
                          gap: "12px",
                        }}
                      >
                        <LocalShippingIcon
                          color="primary"
                          sx={{
                            fontSize: "22px",
                            border: "1px solid #eceef0",
                            borderRadius: "50%",
                            padding: "0px",
                          }}
                        />
                        Tracking Service: {row?.tracking_service}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Button
                        sx={{
                          padding: "6px 20px",
                          display: "block",
                          marginBottom: "8px",
                        }}
                        variant="contained"
                        onClick={() =>
                          handleServiceStatus(row?.service_id, row?.is_active)
                        }
                      >
                        {row?.is_active === true ? (
                          <InsideButton>
                            <ClearIcon
                              sx={{
                                fontSize: "16px",
                              }}
                            />
                            <p>Deactivate</p>
                          </InsideButton>
                        ) : row?.is_active === false ? (
                          <InsideButton>
                            <DoneAllIcon
                              sx={{
                                fontSize: "16px",
                              }}
                            />
                            <p>Activate</p>
                          </InsideButton>
                        ) : (
                          ""
                        )}
                      </Button>
                      Activated on: {row?.activated_on}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <NoDataFound data={serviceData ?? []} />
        </TableContainer>
      </Card>
    </>
  );
};
const InsideButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 12px;
`;
export default Services;
